// State management
let minLoadedPage = 1;
let maxLoadedPage = 1;
let pagesLoaded = 1;

// URL management functions
const getUrlPage = () => {
	const urlParams = new URLSearchParams(window.location.search);
	return parseInt(urlParams.get("page")) || 1;
};

const updateUrlPage = (page) => {
	const url = new URL(window.location);
	if (page <= 1) {
		url.searchParams.delete("page");
	} else {
		url.searchParams.set("page", page);
	}
	history.replaceState({}, "", url);
};

const getPageUrl = (pageNum) => {
	const url = new URL(window.location);
	if (pageNum <= 1) {
		url.searchParams.delete("page");
	} else {
		url.searchParams.set("page", pageNum);
	}
	return url.toString();
};

// Progress bar update function
const updateProgress = (loadedPages) => {
	const progressBar = document.querySelector(".js-collection-progress");
	if (!progressBar) return;

	const perPage = parseInt(progressBar.dataset.productsPerPage);
	const total = parseInt(progressBar.dataset.totalProducts);
	const countEl = progressBar.querySelector(".js-progress-count");
	const totalEl = progressBar.querySelector(".js-progress-total");
	const barEl = progressBar.querySelector(".js-progress-bar");

	const seen = Math.min(loadedPages * perPage, total);
	const percentage = (seen / total) * 100;

	if (countEl) countEl.textContent = seen;
	if (totalEl) totalEl.textContent = total;
	if (barEl) barEl.style.width = percentage + "%";
};

const animateImages = () => {
	const sections = document.querySelectorAll(".section-main-blog");

	sections.forEach((item) => {
		if (item.querySelectorAll(".observe-me").length > 0) {
			function createObserver() {
				function handleIntersect(entries, observer) {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							let css_classlist = entry.target.classList;
							css_classlist.add("is-inview");

							observer.unobserve(entry.target);

							setTimeout(() => {
								css_classlist.remove("is-inview");
								css_classlist.remove("observe-me");
							}, 1000); // Duration matches the animation duration in SCSS
						}
					});
				}

				let options = {
					root: null,
					rootMargin: "0px",
					threshold: 0.0,
				};

				let observer = new IntersectionObserver(handleIntersect, options);
				let targets = item.querySelectorAll(".observe-me");
				targets.forEach((target, index) => {
					observer.observe(target);
				});
			}

			createObserver();
		}
	});
};

const loadItems = (button) => {
	const totalPages = parseInt($("[data-total-pages]").val());
	let currentPage = parseInt($("[data-current-page]").val());
	let currentPageScroll = currentPage + 1;

	// Don't load if already at last page
	if (currentPage >= totalPages) {
		button.remove();
		return;
	}

	currentPage = currentPage + 1;
	const nextUrl = $("[data-next-url]")
		.val()
		.replace(/page=[0-9]+/, "page=" + currentPage);
	const nextUrlScroll = $("[data-next-url]")
		.val()
		.replace(/page=[0-9]+/, "page=" + currentPageScroll);
	$("[data-current-page]").val(currentPage);

	button.setAttribute("disabled", "");
	button.classList.add("loading");

	$.ajax({
		url: nextUrl,
		type: "GET",
		dataType: "html",
		success: function (responseHTML) {
			const newContent = $(responseHTML).find(".load-more-grid").html();
			
			// Only update if there's actual content
			if (newContent && newContent.trim()) {
				// Save progress bar visibility state
				const progressBar = document.querySelector(".js-collection-progress");
				const wasVisible = progressBar ? progressBar.classList.contains("visible") : false;
				
				$(".load-more-grid").append(newContent);
				colorSwatches();
				
				// Update state only on successful content load
				maxLoadedPage++;
				pagesLoaded++;
				updateUrlPage(maxLoadedPage);
				updateProgress(pagesLoaded);
				
				// Restore progress bar visibility state after a short delay
				if (progressBar && wasVisible) {
					setTimeout(() => {
						progressBar.classList.add("visible");
					}, 50);
				}
			}
		},
		complete: function () {
			if (currentPage <= totalPages) {
				const scollData = document.querySelector(".infinite-scroll__data");
				if (scollData && currentPage != totalPages) {
					scollData.querySelector("input[data-next-url]").dataset.nextUrl =
						nextUrlScroll;
					scollData.querySelector("input[data-next-url]").value = nextUrlScroll;
					scollData.querySelector(
						"input[data-current-page]"
					).dataset.currentPage = currentPage;
					scollData.querySelector("input[data-current-page]").value =
						currentPage;
					checkVisibility();
				}
				button.removeAttribute("disabled");
				button.classList.remove("loading");
				if (currentPage == totalPages) {
					button.remove();
				}

				animateImages();
				document.dispatchEvent(new CustomEvent('load-more:loaded'));
			}
		},
	});
};

const checkVisibility = () => {
	const spinnerList = document.querySelectorAll(".js-infinite-scroll");
	spinnerList.forEach((spinner) => {
		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					loadItems(spinner);
					sectionObserver.unobserve(entry.target);
				}
			});
		}, {
			root: null,
			rootMargin: "0px 0px 350px 0px",
			threshold: 0
		});

		sectionObserver.observe(spinner);
	});
};

// Load previous page function
const loadPreviousItems = (button) => {
	if (minLoadedPage <= 1) {
		button.style.display = "none";
		return;
	}

	const prevPage = minLoadedPage - 1;
	const prevUrl = getPageUrl(prevPage);

	const spinner = button.querySelector(".loading-overlay__spinner");
	if (spinner) spinner.classList.remove("hidden");
	
	button.setAttribute("disabled", "");
	button.classList.add("loading");


	$.ajax({
		url: prevUrl,
		type: "GET",
		dataType: "html",
		success: function (responseHTML) {
			const prevContent = $(responseHTML).find(".load-more-grid").html();
			
			// Only update if there's actual content
			if (prevContent && prevContent.trim()) {
				// Save progress bar visibility state
				const progressBar = document.querySelector(".js-collection-progress");
				const wasVisible = progressBar ? progressBar.classList.contains("visible") : false;
				
				$(".load-more-grid").prepend(prevContent);
				colorSwatches();

				// Update state only on successful content load
				minLoadedPage--;
				pagesLoaded++;
				updateUrlPage(minLoadedPage);
				updateProgress(pagesLoaded);

				// Hide button if we're at page 1
				if (minLoadedPage <= 1) {
					button.style.display = "none";
				}
				
				// Restore progress bar visibility state after a short delay
				if (progressBar && wasVisible) {
					setTimeout(() => {
						progressBar.classList.add("visible");
					}, 50);
				}
			}
		},
	complete: function () {
		const spinner = button.querySelector(".loading-overlay__spinner");
		if (spinner) spinner.classList.add("hidden");
		
		button.removeAttribute("disabled");
		button.classList.remove("loading");
		animateImages();
		document.dispatchEvent(new CustomEvent('load-more:loaded'));
	},
	});
};

// Progress bar visibility observer
let progressBarObserver = null;
const observeProgressBar = () => {
	const progressBar = document.querySelector(".js-collection-progress");
	const productGrid = document.querySelector("#product-grid");
	
	if (!progressBar || !productGrid) return;

	// Disconnect existing observer if any
	if (progressBarObserver) {
		progressBarObserver.disconnect();
	}

	progressBarObserver = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			// Only update visibility during actual scroll, not DOM mutations
			if (entry.isIntersecting) {
				progressBar.classList.add("visible");
			} else {
				progressBar.classList.remove("visible");
			}
		});
	}, {
		root: null,
		rootMargin: "-600px 0px 0px 0px",
		threshold: [0, 0.1]
	});

	progressBarObserver.observe(productGrid);
};

function loadMore() {
	// Initialize state from URL or current page
	const currentPage = getUrlPage();
	minLoadedPage = currentPage;
	maxLoadedPage = currentPage;
	pagesLoaded = 1;

	// Update progress on load
	updateProgress(pagesLoaded);

	// Observe progress bar visibility
	observeProgressBar();

	// Load more button
	document.querySelectorAll(".js-load-more").forEach((button) => {
		button.onclick = () => {
			loadItems(button);
		};
	});

	// Show previous button
	document.querySelectorAll(".js-show-prev-products").forEach((button) => {
		button.onclick = () => {
			loadPreviousItems(button);
		};
	});

	checkVisibility();
	animateImages();
}

(function () {
	loadMore();
})();
